import React, { useState, useEffect } from 'react'
import Chart from 'react-apexcharts'

import { Card, Form, Row, Typography } from 'antd'

import EmptyData from '../../../assets/images/ico_dashboard.svg'
import { getMessage } from '../../../util/IntlMessages'
import ChartHeader from '../../Dashboard/Cultivars/charts/ChartHeader'
import './PlantingTime.css'

const PlantingTime = ({ values }) => {
  const [formValues, setFormValues] = useState({})

  const [opening, setOpening] = useState({})
  const [intermediary, setIntermediary] = useState({})
  const [closure, setClosure] = useState({})

  const [totalFields, setTotalFields] = useState(0)

  useEffect(() => {
    if (values) {
      const [openingFormatted] = values.filter((d) => d.planting_time.includes('Abertura'))
      const [intermediaryFormatted] = values.filter((d) => d.planting_time.includes('Intermediário'))
      const [closureFormatted] = values.filter((d) => d.planting_time.includes('Fechamento'))

      setOpening(openingFormatted)
      setIntermediary(intermediaryFormatted)
      setClosure(closureFormatted)

      let sumValues = 0

      values.forEach((d) => {
        for (const [key, value] of Object.entries(d)) {
          if (key === 'total') {
            sumValues += value
          }
        }
      })

      setTotalFields(sumValues)
    } else {
      setFormValues({})
      setOpening({})
      setIntermediary({})
      setClosure({})
      setTotalFields(0)
    }
  }, [values])

  const options = {
    options: {
      chart: {
        type: 'bar',
        stacked: true,
        stackType: '100%',
        toolbar: {
          show: false
        }
      },
      xaxis: {
        categories: [2001],
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      yaxis: {
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      colors: ['#843EF7', '#EBEDF0'],
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: 30,
        style: {
          fontSize: '12px',
          colors: ['#000']
        },
        formatter(val, opt) {
          if (opt.w.config.series[0].data[0] !== 'undefined' && val === opt.w.config.series[0].data[0]) {
            return val + ' %'
          }
        }
      },
      tooltip: {
        enabled: false
      },
      legend: {
        show: false
      }
    }
  }

  if (Object.keys(formValues).length > 0) {
    filterNormalize(formValues)
  }

  function filterNormalize(params) {
    const { materialsI2xFilter = [], materialsCheckFilter = [] } = params

    return {
      materialsI2x: materialsI2xFilter,
      materialsCheck: materialsCheckFilter
    }
  }

  function handlerPercentData(data) {
    if (data && data !== undefined) {
      return data.toFixed(2)
    }
  }

  return (
    <Card className="planting-time">
      <ChartHeader title={getMessage('plantingTime')} />

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Form style={{ width: '100%', marginLeft: '-15px' }} layout="vertical">
          {/*<MaterialAndCheckFilter values={formValues} setFieldValueWithState={setFieldValueWithState} />*/}
        </Form>

        <Card style={{ width: '50%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p style={{ fontWeight: 'bold', fontSize: '14px' }}>Número total de campos</p>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px' }}>
                <p style={{ fontWeight: 'bold', color: '#843EF7', fontSize: '29px', margin: '0px' }}>{totalFields}</p>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {values !== undefined && values.length > 0 ? (
        <div className="content">
          <div className="card mr-10">
            <p className="subtitle">{opening ? opening.planting_time : ''}</p>

            <Row type="flex" justify="space-between">
              <p className="description">{opening ? opening.total : 0}</p>
            </Row>

            <div className="m-chart">
              <Chart
                type="bar"
                height={90}
                options={{ ...options.options, colors: ['#843EF7', '#EBEDF0'] }}
                series={[
                  { data: [`${opening ? handlerPercentData(opening.percents) : 0}`] },
                  { data: [`${opening ? 100 - handlerPercentData(opening.percents) : 100}`] }
                ]}
              />
            </div>
          </div>

          <div className="card ml-10">
            <p className="subtitle">Intermediário</p>

            <Row type="flex" justify="space-between">
              <p className="description">{intermediary ? intermediary.total : 0}</p>
            </Row>

            <div className="m-chart">
              <Chart
                options={{ ...options.options, colors: ['#04D1D1', '#EBEDF0'] }}
                series={[
                  { data: [`${intermediary ? handlerPercentData(intermediary.percents) : 0}`] },
                  { data: [`${intermediary ? 100 - handlerPercentData(intermediary.percents) : 100}`] }
                ]}
                type="bar"
                height={90}
              />
            </div>
          </div>

          <div className="card ml-10">
            <p className="subtitle">Fechamento</p>

            <Row type="flex" justify="space-between">
              <p className="description">{closure ? closure.total : 0}</p>
            </Row>

            <div className="m-chart">
              <Chart
                options={{ ...options.options, colors: ['#22C787', '#EBEDF0'] }}
                series={[
                  { data: [`${closure ? handlerPercentData(closure.percents) : 0}`] },
                  { data: [`${closure ? 100 - handlerPercentData(closure.percents) : 100}`] }
                ]}
                type="bar"
                height={90}
              />
            </div>
          </div>
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: 292 }}>
            <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
            <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 14 }}>
              {'Sem dados'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -50 }}
            >
              {'Escolha materiais para exibir'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -120 }}
            >
              {'esse relatório'}
            </Typography>
          </div>
        </div>
      )}
    </Card>
  )
}

export default PlantingTime
